
const Loading = () => {
    return(
        <div className='loading-spinner'>
        </div>
    )
}

export default Loading